// extracted by css-extract-rspack-plugin
export default {"cls1":"FollowActionButton-cls1_KVk","cls2":"FollowActionButton-cls2_C7M FollowActionButton-cls1_KVk"};